export const iconFontAwesomeMapsGamepad = (
	<i className="fa-solid fa-gamepad"></i>
);
